import { render, staticRenderFns } from "./Infrastructure.vue?vue&type=template&id=5b650aa2&scoped=true&"
import script from "./Infrastructure.vue?vue&type=script&lang=js&"
export * from "./Infrastructure.vue?vue&type=script&lang=js&"
import style0 from "./Infrastructure.vue?vue&type=style&index=0&id=5b650aa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b650aa2",
  null
  
)

export default component.exports